/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import Block = Models.Block;

    export interface IBlocksModalScope extends ng.IScope {
        blocks: Block[];
        type: string;
        modalClose: () => void;
        modalSave: (selectedBlock: Block) => void;
    }

    /**
     * BlocksModalController class
     */
    export class BlocksModalController {
        public static templateURL: string = "decorators/modals/blocks-modal.html";
        public static ID: string = "#id-blocks-modal";
        public static $name: string = "blocksModalController";
        public static $inject: string[] = ['$scope', 'close', 'blocks', 'type'];

        private $scope: IBlocksModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IBlocksModalScope, close: (parameters: ngModal.ICloseParameters) => void,
                    blocks: Block[], type: string) {
            this.$scope = $scope;
            this.$scope.blocks = blocks;
            this.$scope.type = type;
            this.close = close;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (block: Block): void => {
                this.close(block);
            };
        }
    }
}
